
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/object/[id]",
      function () {
        return require("private-next-pages/object/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/object/[id]"])
      });
    }
  